import instance from "../../axios";
import { checkPrivileges } from "../../Helpers";

export const getGroups = groups => ({
  type: 'GET_GROUPS',
  groups
})
export const updateGroups = groups => ({
  type: 'UPDATE_GROUPS',
  groups
});
export const updateGroup = group => ({
  type: 'UPDATE_GROUP',
  group
});
export const addGroup = group => ({
  type: 'ADD_GROUP',
  group
});

export const removeGroup = group => ({
  type: 'REMOVE_GROUP',
  group
});

export const isGroupLoad = (loadGroup) => ({
  type: 'LOAD_GROUPS',
  loadGroup
});

export const saveGroupWiseDevices = payload => {
  return { type: 'SAVE_GROUP_WISE_DEVICES', payload }
}


export const fetchGroups = (dispatch, userInfoFront) => {
  if (checkPrivileges('group')) {
    instance({
      url: `/api/groups/get`,
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      params:{
        userId: userInfoFront.id,
        all: true,
        limit: -1
      }
    })
        .then(groups => {
          const { data } = groups
           const newUpdated = data?.map(item => ({
      ...item,
      check: false
    }));
          dispatch(getGroups(newUpdated))
          dispatch(isGroupLoad(false))
    }).catch(() => {
    })
  }
}
